import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinbhigwanpune() {



const cardData =
  {
    keyword: 'Bus Hire in Bhigwan Pune',
    heading: 'Sanavi Travels: Bus Hire in Bhigwan Pune',
    headingDescription: 'Sanavi Travels offers professional and dependable Bus Hire in Bhigwan Pune, designed to serve families, tourists, corporate teams, schools, wedding groups, picnic travelers, and outstation passengers. Bhigwan, widely known as the “Bharatpur of Maharashtra,” attracts visitors throughout the year due to its bird sanctuary, backwaters, and scenic natural beauty, making organized group transportation an essential requirement. To meet these diverse travel needs, we provide a wide range of AC buses, Non-AC buses, luxury coaches, mini buses, and large-capacity buses suitable for short local trips as well as long-distance journeys. Every bus is regularly maintained with comfortable seating, clean interiors, proper ventilation, smooth suspension, and adequate luggage space to ensure a relaxed and safe travel experience. Our experienced drivers are well-versed with Bhigwan, Indapur, Daund, Pune city, Solapur highway routes, and nearby rural areas, ensuring punctual pickups, disciplined driving, and smooth navigation. Whether you are planning a bird-watching tour, wedding transportation, corporate outing, school picnic, or outstation trip, Sanavi Travels provides flexible rental packages, transparent pricing, and 24/7 customer support. Choose Sanavi Travels for Bus Hire in Bhigwan Pune and enjoy reliable, comfortable, and stress-free group travel for every occasion.',

    top: 'Top Places to Visit in Bhigwan Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Bhigwan Bird Sanctuary is one of Maharashtra’s most famous bird-watching destinations, attracting nature lovers, photographers, and tourists from across India. Migratory birds such as flamingos, pelicans, and cranes visit the area seasonally, making it ideal for group tours and eco-tourism trips. Bus hire services are commonly used by tourists, schools, and photography groups to reach the sanctuary comfortably and travel together safely."
  },
  {
    "title": "Ujani Backwaters",
    "description": "The backwaters of Ujani Dam near Bhigwan offer breathtaking scenic views, boating experiences, and peaceful surroundings. Visitors often travel in groups for sunrise and sunset views, leisure outings, and nature photography. Hiring a bus ensures smooth travel, easy coordination, and a relaxed journey for large groups visiting the backwaters."
  },
  {
    "title": "Bhigwan Town Area",
    "description": "Bhigwan town serves as a local hub for tourism, fishing communities, markets, and lodging facilities. Group travel is frequent for family functions, social gatherings, and tourist movements within the town. Bus hire services help manage transportation efficiently, especially during peak tourist seasons."
  },
  {
    "title": "Fishing Villages Around Bhigwan",
    "description": "The villages around Bhigwan are known for fishing activities linked to the Ujani reservoir. These areas offer a glimpse into rural life and local livelihoods. Organized group travel by bus allows visitors to explore these villages comfortably without disturbing local transportation."
  },
  {
    "title": "Indapur and Daund Connectivity",
    "description": "Bhigwan is well-connected to Indapur and Daund, making these towns important transit and support points for travelers. Many tourists and locals use bus rental services for group travel between Bhigwan, Indapur, Daund, and Pune city."
  },
  {
    "title": "Pune–Solapur Highway Access",
    "description": "The Pune–Solapur Highway provides excellent connectivity to Bhigwan, supporting smooth outstation travel. Bus hire services are ideal for long-distance travel on this route, offering safety, comfort, and cost efficiency for large groups."
  },
  {
    "title": "Religious and Local Temples",
    "description": "Several small temples and spiritual centers around Bhigwan attract devotees throughout the year. Group visits during festivals and religious occasions often rely on bus hire for convenient and organized travel."
  },
  {
    "title": "Picnic and Nature Spots",
    "description": "Open landscapes, lakeside areas, and nature trails near Bhigwan make it a popular picnic destination for schools, colleges, and families. Bus rentals ensure safe group movement and enjoyable journeys."
  },
  {
    "title": "Educational Tours and School Trips",
    "description": "Bhigwan is frequently visited by schools for educational tours focused on ecology, bird life, and environmental studies. Hiring a bus provides safe, supervised, and punctual transportation for students and teachers."
  },
  {
    "title": "Outstation Travel Destinations",
    "description": "Bhigwan serves as a starting point for travel to Pune, Solapur, Baramati, Ahmednagar, and nearby pilgrimage destinations. Bus rentals make outstation group travel comfortable and economical."
  }
]
,



"services": [
{
"name": "Bus Hire in Bhigwan Pune",
"description": "Bus Hire in Bhigwan Pune offers spacious, comfortable, and professionally managed buses for tourists, families, corporate groups, schools, and event travelers. Ideal for bird sanctuary visits, weddings, picnics, corporate outings, and long-distance travel, these buses are equipped with clean interiors, cushioned seating, proper ventilation, and ample luggage space. Experienced drivers ensure punctual pickups, disciplined driving, and safe navigation across rural and highway routes, making group travel smooth and stress-free."
},
{
"name": "Bus on Rent Bhigwan",
"description": "Bus on Rent Bhigwan provides flexible rental solutions for local and outstation travel, suitable for tourists, villagers, and event organizers. With reliable vehicles and professional service, it ensures comfortable and organized group transportation."
},
{
"name": "AC Bus Rental Bhigwan",
"description": "AC Bus Rental Bhigwan is ideal for summer travel and long journeys, offering air-conditioned interiors, enhanced comfort, and a relaxed travel experience for weddings, corporate trips, and tourist groups."
},
{
"name": "Non AC Bus Hire Bhigwan",
"description": "Non AC Bus Hire Bhigwan offers economical transportation for short routes, school trips, and rural travel while maintaining safety and reliability."
},
{
"name": "Luxury Bus Hire Bhigwan",
"description": "Luxury Bus Hire Bhigwan delivers premium travel with stylish interiors, superior seating, and enhanced comfort, suitable for weddings, VIP travel, and special occasions."
},
{
"name": "Mini Bus Hire Bhigwan Pune",
"description": "Mini Bus Hire Bhigwan Pune is perfect for small to medium-sized groups such as families, office teams, and tourist batches, offering flexibility and cost-effective travel."
},
{
"name": "32 Seater Bus Hire Bhigwan",
"description": "32 Seater Bus Hire Bhigwan supports school trips, corporate outings, and medium group travel with balanced capacity and comfort."
},
{
"name": "35 Seater Bus Rental Bhigwan",
"description": "35 Seater Bus Rental Bhigwan is ideal for large groups attending weddings, religious tours, and long-distance journeys with organized seating."
},
{
"name": "Bus Hire Bhigwan for Wedding",
"description": "Bus Hire Bhigwan for Wedding ensures timely and coordinated transportation for wedding guests, simplifying event logistics and reducing travel stress."
},
{
"name": "Bus Hire Bhigwan for Corporate Travel",
"description": "Bus Hire Bhigwan for Corporate Travel offers professional transport solutions for employee movement, meetings, and team outings."
},
{
"name": "Bus Hire Bhigwan for Picnic",
"description": "Bus Hire Bhigwan for Picnic provides safe and enjoyable group travel for schools, colleges, and families visiting nature and leisure spots."
},
{
"name": "Bus Rental Bhigwan Outstation",
"description": "Bus Rental Bhigwan Outstation offers dependable long-distance travel services with comfort, safety, and reliable scheduling."
},
{
"name": "Bus Hire Bhigwan with Driver",
"description": "Bus Hire Bhigwan with Driver provides chauffeur-driven buses where experienced drivers handle routes, traffic, and safety."
},
{
"name": "Cheap Bus Hire Bhigwan Pune",
"description": "Cheap Bus Hire Bhigwan Pune delivers budget-friendly transportation without compromising on cleanliness, safety, or service quality."
},
{
"name": "Best Bus Service Bhigwan",
"description": "Best Bus Service Bhigwan is known for clean buses, punctual service, transparent pricing, and customer satisfaction through Sanavi Travels."
}
],
"tableData": [
["Bus Hire in Bhigwan Pune", "Bus on Rent Bhigwan"],
["AC Bus Rental Bhigwan", "Non AC Bus Hire Bhigwan"],
["Luxury Bus Bhigwan", "Mini Bus Hire Bhigwan"],
["32 Seater Bus Bhigwan", "35 Seater Bus Bhigwan"],
["Wedding Bus Bhigwan", "Corporate Bus Bhigwan"],
["Picnic Bus Bhigwan", "Outstation Bus Bhigwan"],
["Bus Hire Bhigwan with Driver", "Cheap Bus Hire Bhigwan"],
["Best Bus Service Bhigwan", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Bhigwan Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and professional bus hire services in Bhigwan Pune for tourism, events, and group travel."
  },
  {
    "WhyChooseheading": "Comfortable and Clean Buses",
    "WhyChoosedescription": "All buses are regularly maintained and cleaned to ensure passenger comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers",
    "WhyChoosedescription": "Drivers are familiar with Bhigwan, Ujani, Daund, and Pune routes for safe travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Support",
    "WhyChoosedescription": "Round-the-clock customer support for bookings and assistance."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Hourly, full-day, and outstation packages available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are sanitized before every trip."
  },
  {
    "WhyChooseheading": "On-Time Service",
    "WhyChoosedescription": "Guaranteed punctual pickups and reliable operations."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services in Bhigwan Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus hire services in Bhigwan Pune.'
  },
  {
    question: 'What buses are available in Bhigwan?',
    answer: 'AC buses, Non AC buses, mini buses, luxury buses, 32-seater and 35-seater buses are available.'
  },
  {
    question: 'Is bus hire available for bird sanctuary tours?',
    answer: 'Yes, we provide bus hire for Bhigwan bird sanctuary and tourism trips.'
  },
  {
    question: 'Can I book a bus for outstation travel from Bhigwan?',
    answer: 'Yes, outstation bus rentals are available from Bhigwan.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are sanitized before every journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshmukh',
    feedback: 'Excellent bus service for our Bhigwan bird sanctuary trip. Very comfortable journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'We hired a bus from Bhigwan for a picnic. Clean bus and very cooperative driver.',
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Bhigwan Pune - Sanavi Travels",
  "description": "Sanavi Travels provides bus hire in Bhigwan Pune for weddings, corporate travel, picnics, and outstation trips. We offer AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire in Bhigwan Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus hire in Bhigwan Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/226.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinbhigwanpune;